import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Header from './Header';
import Footer from './Footer';

class BasePreAuth extends Component {
  render() {
    const { children, step } = this.props;
    return (
      <div className="background-container">
        <div className="background-wave">
          <img src="/img/pre-auth-bottom-wave.svg" />
        </div>
        <div className="wrapper pre-auth">
          <Header type="pre" step={step} />
          <section className="section-container">{children}</section>
        </div>
        <Footer />
      </div>
    );
  }
}

BasePreAuth.propTypes = {
  children: PropTypes.instanceOf(Object),
  step: PropTypes.number,
};
const mapStateToProps = (state) => ({
  step: state.signup.step,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BasePreAuth);
